import { Avatar, Divider, Grid, Typography } from "@mui/material";
import { useGetRapidCryptoQuery } from "../services/RapidCryptoApi";
import { Fragment, useState } from "react";
import LoadingPage from "../components/LoadingScreen";
import CryptoStats from "../components/Home/CryptoStats";
import Top10Cryptos from "../components/Home/Top10Cryptos";

import NewsComponent from "../components/News/NewsComponent";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loadingActions } from "../store/loading-slice";

const Home = () => {
  const [isCountTen, setIsCountTen] = useState(true);
  const dispatch = useDispatch();

  const { isLoading, isError, data, error, isSuccess } = useGetRapidCryptoQuery(
    isCountTen ? 10 : 100
  );
  if (isLoading) {
    dispatch(loadingActions.openHandler())
    return <LoadingPage />;
  }
  if (isError) {
    return <p>{error}</p>;
  }

  if (isSuccess) {
    dispatch(loadingActions.closeHandler());
  }
  console.log(data);

  return (
    <Fragment>
      <CryptoStats data={data} />
      <Top10Cryptos
        data={data}
        isCountTen={isCountTen}
        setIsCountTen={setIsCountTen}
      />
      <Typography variant="h4" sx={{ fontWeight: 500 }} align="center">
        Crypto News
      </Typography>
      <NewsComponent shortView />
      <Grid container justifyContent={"flex-end"} sx={{ mt: 2 }}>
        <Grid item>
          <Typography
            component={Link}
            to="/news"
            onClick={() => setIsCountTen((prev) => !prev)}
            sx={{ mr: 2, color: "primary.main", cursor: "pointer" }}
            variant="h6"
          >
            See More
          </Typography>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Home;
